import { render, staticRenderFns } from "./GlobalSubPhasesList.vue?vue&type=template&id=fa0116f0&scoped=true&"
import script from "./GlobalSubPhasesList.vue?vue&type=script&lang=ts&"
export * from "./GlobalSubPhasesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0116f0",
  null
  
)

export default component.exports